const DEFAULT_TEACHER_DASHBOARD_URL = "http://localhost:3002";

const normaliseEnvironmentUrl = (url) =>
  String(url || "")
    .trim()
    .replace(/^['"]|['"]$/g, "")
    .replace(/\/+$/g, "");

export const getTeacherDashboardUrl = (path, explicitUrl = "") => {
  const normalisedExplicitUrl = normaliseEnvironmentUrl(explicitUrl);

  if (normalisedExplicitUrl) {
    return normalisedExplicitUrl;
  }

  const tdBaseUrl =
    normaliseEnvironmentUrl(process.env.REACT_APP_TD_URL) ||
    DEFAULT_TEACHER_DASHBOARD_URL;
  const normalisedPath = String(path || "").startsWith("/")
    ? path
    : `/${path || ""}`;

  return `${tdBaseUrl}${normalisedPath}`;
};

export const getTeacherDashboardAdminUrl = () =>
  getTeacherDashboardUrl(
    "/admindashboard",
    process.env.REACT_APP_TD_ADMIN_DASHBOARD
  );

export const returnToTeacherDashboard = (path = "/admindashboard") => {
  const destination =
    path === "/admindashboard"
      ? getTeacherDashboardAdminUrl()
      : getTeacherDashboardUrl(path);

  window.location.href = destination;
};
